import { BidCategoryView } from '@api-proxies';
import { BidCategoryService } from '@http/clients/bid-category.service';
import { IComponentEditorEntity } from '../../entity-interfaces/editor-entity.interface';

export abstract class BidCategoryEntity<TEntityDestination>
    implements IComponentEditorEntity<BidCategoryView, TEntityDestination>
{
    constructor(readonly bidCategoryService: BidCategoryService) {}

    abstract toDestination(entity: BidCategoryView): TEntityDestination;

    abstract toSource(entity: TEntityDestination): BidCategoryView;

    async getSource(): Promise<BidCategoryView[]> {
        return await this.bidCategoryService.search();
    }
}
